import { useHelp } from './HelpContext';
import { CircleHelp } from 'lucide-react';

export function HelpButton() {
  const { open } = useHelp();
  return (
    <button
      type="button"
      aria-label="Help"
      onClick={open}
      className="rounded p-2 text-slate-300 hover:bg-slate-800"
      data-testid="help-button"
    >
      <CircleHelp className="h-5 w-5" aria-hidden />
    </button>
  );
}